import React, { useEffect, Children, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import fetchWrapper, { getConnection } from '@interhyp/util-request';
import { makeTranslation } from '@interhyp/util-translation';
import { getAPIPath } from '@interhyp/platform-request';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useTracking, TRACK_EVENT } from '@interhyp/util-tracking';
import logo from './assets/bc6f61094fcfcbc19c699d504d1ee69b.svg';
import { Icon, Typography, Grid, GridItem, Button, Separator, Link } from '@platform/elements';
import { checkmark, arrowRight, liveAdvice } from '@platform/icons';
import cs from 'classnames';
import logo$1 from './assets/cebc5a95e731682d18db0bdda26f4fd8.svg';
import { useHistory } from '@interhyp/platform-router';
import moment from 'moment';
import { BREAKPOINT_NAMES, useResponsiveBreakpoints } from '@interhyp/util-hooks';
import advisorImg from './assets/cb03b93e53f27a5c0b9888390716afd6.jpg';
import cubeImg from './assets/0b7efd154f80ee4788f4d69c4d788e50.jpg';
import { isDesktop } from '@interhyp/util-detection';

async function getIntentAdvisorImage(intentId) {
  const res = await fetchWrapper(getConnection(), `/api/advisory-excellence-portal/home/api/customers/advisor/v1/intent/${intentId}/profileImage`);
  if (res.status === 200) {
    return res.text();
  }
}

async function getIntentAdvisorProfile(intentId) {
  const res = await fetchWrapper(getConnection(), `/api/advisory-excellence-portal/home/api/customers/advisor/v1/intent/${intentId}/contact`);
  if (res.status === 200) {
    return res.json();
  }
}

const ADVISOR_SET_DATA_LOADING = `PersonalAdvisor/dataLoading`;
const ADVISOR_SET_IMAGE_LOADING = `PersonalAdvisor/imageLoading`;
const ADVISOR_SET_DATA = `PersonalAdvisor/data`;
const ADVISOR_SET_IMAGE = `PersonalAdvisor/img`;
const loadingAdvisorData = () => ({
  type: ADVISOR_SET_DATA_LOADING
});
const loadingAdvisorImage = () => ({
  type: ADVISOR_SET_IMAGE_LOADING
});
const setAdvisorImage = imgSrc => ({
  type: ADVISOR_SET_IMAGE,
  payload: {
    imgSrc
  }
});
const setAdvisor = advisor => ({
  type: ADVISOR_SET_DATA,
  payload: {
    advisor
  }
});
function loadAdvisor(intentId) {
  return async dispatch => {
    dispatch(loadingAdvisorData());
    dispatch(loadingAdvisorImage());
    const advisorData = await getIntentAdvisorProfile(intentId);
    const advisorImg = await getIntentAdvisorImage(intentId);
    dispatch(setAdvisorImage(advisorImg));
    dispatch(setAdvisor(advisorData));
    dispatch(loadingAdvisorData());
    dispatch(loadingAdvisorImage());
  };
}

function getAdvisorData(state) {
  const {
    PersonalAdvisor: {
      advisor,
      imgSrc
    }
  } = state;
  return {
    advisor,
    imgSrc
  };
}

function useAdvisorData(intentId) {
  const dispatch = useDispatch();
  const data = useSelector(getAdvisorData);
  useEffect(() => {
    if (intentId) {
      dispatch(loadAdvisor(intentId));
    }
  }, [dispatch, intentId]);
  return data;
}

const useTranslation = makeTranslation('module-page-modules');

async function getIntentAppointments(intentId) {
  if (!intentId) {
    return [];
  }
  const res = await fetch(`${getAPIPath('customers')}/intent/v1/intents/${intentId}/appointments`);
  if (res.status === 200) {
    return res.json();
  }
  return [];
}

const APPOINTMENTS_SET_LOADING = 'appointments/loading';
const APPOINTMENTS_SET_DATA = 'appointments/data';
const loadingAppointments = loading => ({
  type: APPOINTMENTS_SET_LOADING,
  payload: {
    loading
  }
});
const setAppointments = appointments => ({
  type: APPOINTMENTS_SET_DATA,
  payload: {
    appointments
  }
});
function loadAppointments(intentId) {
  return async dispatch => {
    dispatch(loadingAppointments(true));
    const appointments = await getIntentAppointments(intentId);
    dispatch(setAppointments(appointments));
    dispatch(loadingAppointments(false));
  };
}

const INITIAL_STATE$1 = {
  data: null,
  loading: false
};
const AppointmentsReducer = (state = INITIAL_STATE$1, {
  type,
  payload
}) => {
  switch (type) {
    case APPOINTMENTS_SET_LOADING:
      return {
        ...state,
        loading: payload.loading
      };
    case APPOINTMENTS_SET_DATA:
      return {
        ...state,
        data: payload.appointments.length > 0 ? payload.appointments : null
      };
    default:
      return state;
  }
};

const appointmentGet = ({
  appointments
}) => appointments?.data || [];
const appointmentIsLoading = ({
  appointments
}) => appointments?.loading;

let AppointmentType = /*#__PURE__*/function (AppointmentType) {
  AppointmentType["IN_HOUSE"] = "inHouse";
  AppointmentType["BY_PHONE"] = "byPhone";
  AppointmentType["BY_VIDEO"] = "byVideo";
  return AppointmentType;
}({});

var styles$j = {"addressLine":"addressLine_p3BBGEbRLr"};

function AddressLine({
  children
}) {
  return /*#__PURE__*/jsx("div", {
    className: styles$j.addressLine,
    children: children
  });
}

var styles$i = {"bannerBulletOuter":"bannerBulletOuter_thktj-mq9J","icon":"icon_5ou1rMYeYT","bannerBulletText":"bannerBulletText_D71NWOjZFi"};

function BannerBullet({
  children
}) {
  return /*#__PURE__*/jsxs("div", {
    className: styles$i.bannerBulletOuter,
    children: [/*#__PURE__*/jsx(Icon, {
      className: styles$i.icon,
      icon: checkmark,
      size: 16
    }), /*#__PURE__*/jsx("p", {
      className: styles$i.bannerBulletText,
      children: children
    })]
  });
}

var styles$h = {"bannerContentOuter":"bannerContentOuter_XMCOWRgJiF"};

function BannerContent({
  content1,
  content2,
  content3,
  content4
}) {
  return /*#__PURE__*/jsxs("div", {
    className: styles$h.bannerContentOuter,
    children: [/*#__PURE__*/jsx(BannerBullet, {
      children: content1
    }), /*#__PURE__*/jsx(BannerBullet, {
      children: content2
    }), /*#__PURE__*/jsx(BannerBullet, {
      children: content3
    }), content4 && /*#__PURE__*/jsx(BannerBullet, {
      children: content4
    })]
  });
}

var styles$g = {"bannerHeaderOuter":"bannerHeaderOuter_z12IuI-JSk","tagLine":"tagLine_haEigxnKU-","bannerHeaderBreak":"bannerHeaderBreak_opoo9e8osz","bannerHeaderImage":"bannerHeaderImage_02BQSP0YnI"};

function BannerHeader({
  logo,
  header1,
  header2
}) {
  return /*#__PURE__*/jsxs("div", {
    className: styles$g.bannerHeaderOuter,
    children: [/*#__PURE__*/jsx("img", {
      className: styles$g.bannerHeaderImage,
      src: logo,
      alt: ""
    }), /*#__PURE__*/jsxs(Typography, {
      variant: "h4",
      className: styles$g.tagLine,
      children: [header1, /*#__PURE__*/jsx("br", {
        className: styles$g.bannerHeaderBreak
      }), header2]
    })]
  });
}

var styles$f = {"bannerLinkOuter":"bannerLinkOuter_DQ1kc9UGaQ","bannerLinkText":"bannerLinkText_BDF6QOJ7Eq","icon":"icon_4e3RSvEdd1"};

function BannerLink({
  path,
  children,
  onClick
}) {
  const ch = Children.toArray(children);
  const i = ch.lastIndexOf(' ');
  const first = ch.slice(0, i);
  const last = ch.slice(i, ch.length);
  return /*#__PURE__*/jsx("div", {
    className: styles$f.bannerLinkOuter,
    children: /*#__PURE__*/jsxs("a", {
      className: styles$f.bannerLinkText,
      rel: "noopener noreferrer",
      target: "_blank",
      href: path,
      onClick: onClick,
      children: [first, /*#__PURE__*/jsxs("span", {
        style: {
          whiteSpace: 'nowrap'
        },
        children: [last, /*#__PURE__*/jsx(Icon, {
          className: styles$f.icon,
          icon: arrowRight,
          size: 12
        })]
      })]
    })
  });
}

var styles$e = {"grid":"grid_x1rQcEBRhY","bannerWrapperOuter":"bannerWrapperOuter_-xJhlxmvjJ"};

function BannerWrapper({
  children
}) {
  return /*#__PURE__*/jsxs(Grid, {
    className: styles$e.grid,
    noPad: true,
    children: [/*#__PURE__*/jsx(GridItem, {
      md: 1,
      xs: 0
    }), /*#__PURE__*/jsx(GridItem, {
      md: 10,
      xs: 12,
      children: /*#__PURE__*/jsx("div", {
        className: styles$e.bannerWrapperOuter,
        children: children
      })
    }), /*#__PURE__*/jsx(GridItem, {
      md: 1,
      xs: 0
    })]
  });
}

function AsuroBanner({
  url
}) {
  const translate = useTranslation('AsuroBanner');
  const {
    trackEvent
  } = useTracking();
  function handleClick() {
    trackEvent({
      type: TRACK_EVENT,
      payload: {
        packageModule: 'AsuroBanner',
        target: 'Asuro-Link'
      }
    });
  }
  if (!url) {
    return null;
  }
  return /*#__PURE__*/jsxs(BannerWrapper, {
    children: [/*#__PURE__*/jsx(BannerHeader, {
      header1: translate('headline1'),
      header2: translate('headline2'),
      logo: logo
    }), /*#__PURE__*/jsx(BannerContent, {
      content1: translate('contentText1'),
      content2: translate('contentText2'),
      content3: translate('contentText3')
    }), /*#__PURE__*/jsx(BannerLink, {
      path: url,
      onClick: handleClick,
      children: translate('checkRequirements')
    })]
  });
}

var styles$d = {"contentWrapper":"contentWrapper_GH2Onmna6J"};

function ContentWrapper({
  children,
  className
}) {
  return /*#__PURE__*/jsx("div", {
    className: cs([className, styles$d.contentWrapper]),
    children: children
  });
}

var styles$c = {"headline":"headline_7nGF3w-7Lw"};

function Headline({
  children
}) {
  return /*#__PURE__*/jsx(Typography, {
    variant: "h4",
    className: styles$c.headline,
    children: children
  });
}

var styles$b = {"newAppointment":"newAppointment_ATustx4Tbu","descriptionWrapper":"descriptionWrapper_55k36MwTVD","description":"description_NlUIQwJ8lI","cta":"cta_faGoj5NnVV"};

function getHost(env) {
  switch (env) {
    case 'test':
      return 'https://ehyptest.interhyp-intern.de/';
    case 'livetest':
      return 'https://ehyplivetest.interhyp-intern.de/';
    default:
      return 'https://interhyp.de/';
  }
}

function NewAppointment({
  appId
}) {
  const translate = useTranslation('NewAppointment');
  const env = window.process.env.APP_ENV;
  const host = getHost(env);
  const onRedirect = () => {
    window.open(`${host}termin-buchen/?adbID=${appId}`, '_blank');
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles$b.newAppointment,
    children: [/*#__PURE__*/jsx("img", {
      src: logo$1,
      alt: "calendar-logo"
    }), /*#__PURE__*/jsxs("div", {
      className: styles$b.descriptionWrapper,
      children: [/*#__PURE__*/jsx(Typography, {
        margin: false,
        variant: "p",
        className: styles$b.description,
        children: translate('description')
      }), /*#__PURE__*/jsx(Button, {
        secondary: true,
        variant: "text",
        onClick: onRedirect,
        iconRight: arrowRight,
        className: styles$b.cta,
        children: translate('buttonCta')
      })]
    })]
  });
}

var styles$a = {"wrapper":"wrapper_fksUsE2KaQ","titleVideo":"titleVideo_-hCWFCg1ss","titleDefault":"titleDefault_wQpLZG-052","byVideoDescription":"byVideoDescription_d-dxVJweRs","dateOfAppointment":"dateOfAppointment_wM8QHuNgXg","byVideoButton":"byVideoButton_kwZPVZyrxP","address":"address_RHZCBJVHaG","link":"link_NIno5xw1Om"};

var styles$9 = {"wrapperOuter":"wrapperOuter_XlgTKinKKS"};

function Wrapper({
  className,
  children
}) {
  return /*#__PURE__*/jsx("div", {
    className: cs([styles$9.wrapperOuter, className]),
    children: children
  });
}

const trackClick = (trackEvent, target) => {
  trackEvent({
    type: TRACK_EVENT,
    payload: {
      packageModule: 'TerminBox',
      target
    }
  });
};
function getHeadlineTransKey(appointmentType) {
  switch (appointmentType) {
    case AppointmentType.IN_HOUSE:
      return ['inHouseAppointment', {
        $prefix: 'shared'
      }];
    case AppointmentType.BY_PHONE:
      return ['byPhoneAppointment', {
        $prefix: 'shared'
      }];
    case AppointmentType.BY_VIDEO:
      return ['byVideoAppointment', {
        $prefix: 'shared'
      }];
    default:
      return null;
  }
}
function NextAppointment({
  appointments: [appointment] = [],
  className,
  editDataPath = '/start/angaben-d',
  uploadDocumentsPath = '/unterlagen'
}) {
  const translate = useTranslation('NextAppointment');
  const {
    trackEvent
  } = useTracking();
  const {
    push
  } = useHistory();
  if (!appointment) {
    return null;
  }
  const {
    appointmentType,
    dateFrom,
    advisor: {
      city,
      street,
      zipCode
    }
  } = appointment;
  const titleClass = appointmentType === AppointmentType.BY_VIDEO ? styles$a.titleVideo : styles$a.titleDefault;
  return /*#__PURE__*/jsxs(Wrapper, {
    className: cs(styles$a.wrapper, className),
    children: [appointmentType && /*#__PURE__*/jsx(Typography, {
      className: titleClass,
      variant: "h4",
      children: translate(getHeadlineTransKey(appointmentType))
    }), appointmentType === AppointmentType.BY_VIDEO && /*#__PURE__*/jsx("div", {
      className: styles$a.byVideoDescription,
      children: translate('startVideoAppointment.description')
    }), /*#__PURE__*/jsx("div", {
      className: styles$a.dateOfAppointment,
      children: translate('dateOfAppointment', {
        date: moment(dateFrom).format('DD.MM.YYYY'),
        time: moment(dateFrom).format('HH:mm')
      })
    }), appointmentType === AppointmentType.BY_VIDEO && /*#__PURE__*/jsx(Button, {
      variant: "text",
      className: styles$a.byVideoButton,
      iconLeft: liveAdvice,
      secondary: true,
      disabled: moment().diff(dateFrom, 'minutes') <= -5,
      onClick: () => window.open(translate('startVideoAppointment.link'), '_blank', 'noopener,noreferrer'),
      children: translate('startVideoAppointment')
    }), (appointmentType === AppointmentType.IN_HOUSE || !appointmentType) && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: styles$a.address,
        children: street
      }), /*#__PURE__*/jsx("div", {
        className: styles$a.address,
        children: `${zipCode} ${city}`
      })]
    }), /*#__PURE__*/jsx(Separator, {
      marginBottom: "1rem",
      marginTop: "1rem"
    }), /*#__PURE__*/jsx(Link, {
      className: styles$a.link,
      secondary: true,
      onClick: () => {
        push(editDataPath);
        trackClick(trackEvent, 'Termin_Angaben_vervollständigen');
      },
      children: translate('completeData', {
        $prefix: 'shared'
      })
    }), /*#__PURE__*/jsx(Link, {
      className: styles$a.link,
      secondary: true,
      onClick: () => {
        push(uploadDocumentsPath);
        trackClick(trackEvent, 'Termin_Unterlagen_hochladen');
      },
      children: translate('uploadDocuments', {
        $prefix: 'shared'
      })
    })]
  });
}

function NextAppointmentConnected({
  intentId,
  ...rest
}) {
  const dispatch = useDispatch();
  const appointments = useSelector(appointmentGet);
  useEffect(() => {
    if (intentId) {
      dispatch(loadAppointments(intentId));
    }
  }, [dispatch, intentId]);
  if (!appointments || appointments.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx(NextAppointment, {
    appointments: appointments,
    ...rest
  });
}

var styles$8 = {"wrapperClass":"wrapperClass_3-TeDLK78-","small":"small_7M0Z4-0sa-","medium":"medium_A5y5FBLMNg"};

const mailCharacterLimitForSmallScreens = 30;
const mailCharacterLimitForLargeScreens = 40;
function PersonalAdvisorAvatar({
  fullName,
  src,
  size,
  mail
}) {
  let avatarStyle = null;
  const isExtraSmallScreen = size === BREAKPOINT_NAMES.EXTRA_SMALL;
  const isSmallScreen = size === BREAKPOINT_NAMES.SMALL;
  const isLargeScreen = size === BREAKPOINT_NAMES.LARGE;

  // is mail to long on specified container size
  const isMailToLong = useCallback(() => {
    if (!mail?.length) {
      return null;
    }
    return !isLargeScreen && mail.length >= mailCharacterLimitForSmallScreens || isLargeScreen && mail.length >= mailCharacterLimitForLargeScreens;
  }, [isLargeScreen, mail]);
  if (!src) {
    return null;
  }
  if (isExtraSmallScreen) {
    avatarStyle = styles$8.small;
  } else if (isSmallScreen || isMailToLong()) {
    avatarStyle = styles$8.medium;
  }
  return /*#__PURE__*/jsx("div", {
    className: cs(styles$8.wrapperClass, avatarStyle),
    children: /*#__PURE__*/jsx("img", {
      alt: fullName,
      src: src
    })
  });
}

var styles$7 = {"link":"link_jDo6O6CJx2","small":"small_2pvJMrWXNX","highlighted":"highlighted_2SLvxm0qf-"};

function PersonalAdvisorLink({
  className,
  highlighted,
  linkType,
  link,
  children,
  ...rest
}) {
  const href = linkType ? [linkType, link].join(':') : link;
  const classNames = cs(styles$7.link, highlighted && styles$7.highlighted, className);
  return /*#__PURE__*/jsx("a", {
    href: href,
    title: link,
    className: classNames,
    ...rest,
    children: children ?? link
  });
}

var styles$6 = {"list":"list_SHLs8dyh1j","small":"small_R64S5kU8h1"};

function PersonalAdvisorServiceTimes({
  serviceTimes,
  size
}) {
  if (!serviceTimes || !Array.isArray(serviceTimes)) {
    return null;
  }
  return /*#__PURE__*/jsx("ul", {
    className: styles$6.list,
    children: serviceTimes.map(([days, hours]) => /*#__PURE__*/jsxs("li", {
      className: size ? styles$6.small : undefined,
      children: [/*#__PURE__*/jsx("span", {
        children: days
      }), /*#__PURE__*/jsx("span", {
        children: hours
      })]
    }, days))
  });
}

var styles$5 = {"container":"container_WtmAv1FVbE","small":"small_2awYuQUy-T","nameHeadline":"nameHeadline_ZipvCzTcGk","spacedButton":"spacedButton_b8dCpIdS0q","list":"list_Aq96JgYdmu"};

function PersonalAdvisorContent({
  branch,
  city,
  email,
  fullName,
  phone,
  street,
  zip,
  serviceTimes,
  size,
  onMailClick,
  onPhoneClick
}) {
  return /*#__PURE__*/jsxs("div", {
    className: cs(styles$5.container, size ? styles$5.small : null),
    children: [/*#__PURE__*/jsxs("div", {
      children: [fullName && /*#__PURE__*/jsx(Typography, {
        className: styles$5.nameHeadline,
        margin: false,
        variant: "h4",
        children: fullName
      }), /*#__PURE__*/jsxs("ul", {
        className: styles$5.list,
        children: [branch && /*#__PURE__*/jsx("li", {
          children: branch
        }), /*#__PURE__*/jsx("li", {
          children: street
        }), /*#__PURE__*/jsxs("li", {
          children: [zip, " ", city]
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      children: [phone && /*#__PURE__*/jsx(PersonalAdvisorLink, {
        "data-test-id": "phone",
        linkType: "tel",
        link: phone,
        onClick: onPhoneClick
      }), serviceTimes && /*#__PURE__*/jsx(PersonalAdvisorServiceTimes, {
        serviceTimes: serviceTimes,
        size: size
      }), /*#__PURE__*/jsx(PersonalAdvisorLink, {
        className: styles$5.spacedButton,
        "data-test-id": "email",
        linkType: "mailto",
        highlighted: true,
        link: email,
        onClick: onMailClick
      })]
    })]
  });
}

var styles$4 = {"container":"container_ojeFRXsqnK","smallContainer":"smallContainer_vX860hk97p","card":"card_PQQZzEX5Oh","smallCard":"smallCard_Q8wftWdqqI"};

function resolveImage(img, {
  generic
} = {}) {
  if (!img) {
    return generic ? cubeImg : advisorImg;
  }
  return img.includes('data:image/') ? img : `data:image/jpeg;base64,${img}`;
}
function normalizeData(advisor) {
  return {
    ...advisor,
    fullName: advisor.fullName || [advisor.firstName, advisor.lastName].join(' '),
    zip: advisor.zip || advisor.zipCode,
    phone: advisor.phone || advisor.phoneNumber
  };
}
function PersonalAdvisorCard({
  className,
  imgSrc,
  advisor,
  onMailClick,
  onPhoneClick,
  parentClassName
}) {
  const containerRef = React.useRef(null);
  const size = useResponsiveBreakpoints(containerRef, [{
    [BREAKPOINT_NAMES.EXTRA_SMALL]: 337
  }, {
    [BREAKPOINT_NAMES.SMALL]: 360
  }, {
    [BREAKPOINT_NAMES.MEDIUM]: 380
  }, {
    [BREAKPOINT_NAMES.LARGE]: 500
  }]);
  if (!advisor) {
    return null;
  }
  const data = normalizeData(advisor);
  const imageSource = resolveImage(imgSrc, data);
  const containerClass = size === BREAKPOINT_NAMES.EXTRA_SMALL ? styles$4.smallContainer : null;
  const cardClass = size === BREAKPOINT_NAMES.EXTRA_SMALL ? styles$4.smallCard : null;
  const contentSize = size === BREAKPOINT_NAMES.EXTRA_SMALL ? size : undefined;
  return /*#__PURE__*/jsx("div", {
    className: cs(styles$4.container, containerClass, parentClassName),
    ref: containerRef,
    children: /*#__PURE__*/jsxs("div", {
      className: cs(styles$4.card, cardClass, className),
      children: [/*#__PURE__*/jsx(PersonalAdvisorAvatar, {
        src: imageSource,
        fullName: data.fullName,
        mail: data.email,
        size: size
      }), /*#__PURE__*/jsx(PersonalAdvisorContent, {
        ...data,
        size: contentSize,
        onMailClick: onMailClick,
        onPhoneClick: onPhoneClick
      })]
    })
  });
}

var styles$3 = {"wrapper":"wrapper_zTKso28RXw"};

function useTrackableOnClick() {
  const {
    trackEvent
  } = useTracking();
  return target => {
    trackEvent({
      type: TRACK_EVENT,
      payload: {
        packageModule: 'BeraterBox',
        target
      }
    });
  };
}
function PersonalAdvisor({
  className,
  intentId,
  containerClassName
}) {
  const data = useAdvisorData(intentId);
  const handleClick = useTrackableOnClick();
  if (!data.advisor) {
    return null;
  }
  const handleMailClick = () => handleClick('Start_Kontakt_Email');
  const handlePhoneClick = () => handleClick('Start_Kontakt_Telefon');
  return /*#__PURE__*/jsx("div", {
    className: styles$3.wrapper,
    children: /*#__PURE__*/jsx(PersonalAdvisorCard, {
      className: className,
      ...data,
      onMailClick: handleMailClick,
      onPhoneClick: handlePhoneClick,
      parentClassName: containerClassName
    })
  });
}

const INITIAL_STATE = {
  advisor: null,
  imgSrc: null,
  isDataLoading: false,
  isImageLoading: false
};
const StateAdvisorReducer = (state = INITIAL_STATE, {
  type,
  payload
}) => {
  switch (type) {
    case ADVISOR_SET_IMAGE_LOADING:
      return {
        ...state,
        isImageLoading: !state.isImageLoading
      };
    case ADVISOR_SET_DATA_LOADING:
      return {
        ...state,
        isDataLoading: !state.isDataLoading
      };
    case ADVISOR_SET_DATA:
      return {
        ...state,
        advisor: payload.advisor
      };
    case ADVISOR_SET_IMAGE:
      return {
        ...state,
        imgSrc: payload.imgSrc
      };
    default:
      return state;
  }
};

var styles$2 = {"container":"container_OZb8KbnBBo","column":"column_dIDow-5QXS","phoneLine":"phoneLine_4OoC5ybu55","mailLine":"mailLine_lA36zbcIv3","circledPhoto":"circledPhoto_BSFfRT3Bf6"};

function PersonalAdvisorTip({
  advisor,
  imgSrc
}) {
  const translate = useTranslation('PersonalAdvisorTip');
  let imgUrl = imgSrc && `data:image/jpeg;base64,${imgSrc}`;
  if (!imgUrl) {
    imgUrl = advisor.generic ? cubeImg : advisorImg;
  }
  return /*#__PURE__*/jsxs("div", {
    className: styles$2.container,
    children: [/*#__PURE__*/jsx("div", {
      className: styles$2.column,
      children: /*#__PURE__*/jsx("div", {
        className: styles$2.circledPhoto,
        style: {
          backgroundImage: `url('${imgUrl}')`
        }
      })
    }), /*#__PURE__*/jsxs("div", {
      className: styles$2.column,
      children: [advisor.firstName && advisor.lastName && /*#__PURE__*/jsxs(Typography, {
        variant: "h4",
        children: [advisor.firstName, " ", advisor.lastName]
      }), /*#__PURE__*/jsx("div", {
        children: advisor.street
      }), /*#__PURE__*/jsx("div", {
        children: `${advisor.zipCode} ${advisor.city}`
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: styles$2.column,
      children: [advisor.phoneNumber && isDesktop() ? /*#__PURE__*/jsx(Typography, {
        variant: "h4",
        children: advisor.phoneNumber
      }) : /*#__PURE__*/jsx("a", {
        href: `tel:${advisor.phoneNumber}`,
        className: styles$2.phoneLine,
        children: advisor.phoneNumber
      }), /*#__PURE__*/jsx("div", {
        children: advisor.serviceTimes ? /*#__PURE__*/jsx(PersonalAdvisorServiceTimes, {
          serviceTimes: advisor.serviceTimes
        }) : translate('serviceTime')
      }), /*#__PURE__*/jsx("div", {
        className: styles$2.mailLine,
        children: /*#__PURE__*/jsx("a", {
          href: `mailto:${advisor.email}`,
          children: advisor.email
        })
      })]
    })]
  });
}

function PersonalAdvisorConnected({
  intentId
}) {
  const data = useAdvisorData(intentId);
  if (!data.advisor) {
    return null;
  }
  return /*#__PURE__*/jsx(PersonalAdvisorTip, {
    advisor: data.advisor,
    imgSrc: data.imgSrc
  });
}

var styles$1 = {"photoDiv":"photoDiv_RNIejcCcrL"};

function Photo({
  src
}) {
  return /*#__PURE__*/jsx("div", {
    className: styles$1.photoDiv,
    style: {
      backgroundImage: `url('${src}')`
    }
  });
}

var styles = {"routerLinkAnchor":"routerLinkAnchor_g7njdDXcAS"};

function RouteLink({
  children,
  onClick
}) {
  return /*#__PURE__*/jsx(Link, {
    className: styles.routerLinkAnchor,
    onClick: onClick,
    children: children
  });
}

export { ADVISOR_SET_DATA, ADVISOR_SET_DATA_LOADING, ADVISOR_SET_IMAGE, ADVISOR_SET_IMAGE_LOADING, APPOINTMENTS_SET_DATA, APPOINTMENTS_SET_LOADING, AddressLine, AppointmentType, AppointmentsReducer, AsuroBanner, BannerBullet, BannerContent, BannerHeader, BannerLink, BannerWrapper, ContentWrapper, Headline, NewAppointment, NextAppointment, NextAppointmentConnected, PersonalAdvisor, PersonalAdvisorAvatar, PersonalAdvisorCard, PersonalAdvisorConnected, PersonalAdvisorContent, PersonalAdvisorLink, PersonalAdvisorServiceTimes, PersonalAdvisorTip, Photo, RouteLink, StateAdvisorReducer, Wrapper, appointmentGet, appointmentIsLoading, getAdvisorData, getIntentAdvisorImage, getIntentAdvisorProfile, getIntentAppointments, loadAdvisor, loadAppointments, loadingAdvisorData, loadingAdvisorImage, loadingAppointments, normalizeData, resolveImage, setAdvisor, setAdvisorImage, setAppointments, useAdvisorData, useTranslation };
//# sourceMappingURL=index.js.map
